export enum ConnectorNames {
  Injected = 'injected',
  WalletConnect = 'walletconnect',
}

export interface Config {
  title: string
  connectorId: ConnectorNames
  fathomID?: string
  walletID?: string
}
